import { Path, Rect, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Rect x="10" y="7" width="4" height="10" fill="currentColor" stroke="none" />
		<Path d="M4 4.75H20M4 19.25H20" vectorEffect="non-scaling-stroke" />
	</SVG>
);
